import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Custom hook for managing business dialog states and handlers
 * Encapsulates claim, report, and other dialog management
 */
export const useBusinessDialogs = ({ token, businessId, title }) => {
  const navigate = useNavigate();

  // Dialog states
  const [isClaimDialogOpen, setIsClaimDialogOpen] = useState(false);
  const [isReportDialogOpen, setIsReportDialogOpen] = useState(false);

  // Helper function for authentication check
  const requireAuth = (callback) => {
    if (!token) {
      navigate('/auth/signin', { 
        state: { 
          name: 'businessDetails', 
          link: `/business/${businessId}/${title}` 
        } 
      });
      return false;
    }
    return callback();
  };

  // Claim dialog handlers
  const handleOpenClaimDialog = () => {
    console.log('claim clicked');
    return requireAuth(() => {
      setIsClaimDialogOpen(true);
    });
  };

  const handleCloseClaimDialog = () => {
    setIsClaimDialogOpen(false);
  };

  // Report dialog handlers
  const handleOpenReportDialog = () => {
    console.log('report clicked');
    return requireAuth(() => {
      setIsReportDialogOpen(true);
    });
  };

  const handleCloseReportDialog = () => {
    setIsReportDialogOpen(false);
  };

  // Share handler
  const handleShareBusiness = () => {
    console.log('Sharing business profile');
    return requireAuth(() => {
      // TODO: Implement business sharing functionality
      console.log('Share functionality to be implemented');
    });
  };

  return {
    // Dialog states
    dialogStates: {
      isClaimDialogOpen,
      isReportDialogOpen
    },
    // Dialog handlers
    handlers: {
      handleOpenClaimDialog,
      handleCloseClaimDialog,
      handleOpenReportDialog,
      handleCloseReportDialog,
      handleShareBusiness
    }
  };
};